import angular from 'angular';

export default function sortBy($compile, $parse){
    "ngInject";
    return {
        restrict: 'ACEM',
        scope: {
            sort: '='
        },
        link: ($scope, el, attr) => {
            const title = el.text();
            el.text('')
            const elem = angular.element(`<div class="th-inner sortable" ng-class="{'asc': sort === '${attr.sortBy}', 'desc': sort === '-${attr.sortBy}'}">${title}</div>`)
            const tooltip = $compile(elem)($scope);
            el.append(tooltip);
            el.addClass('clickable');
            el.on('click', ($event) => {
                if ($scope.sort === attr.sortBy) {
                    $scope.$apply(() => {
                        $scope.sort = '-'+attr.sortBy;
                    })
                } else {
                    $scope.$apply(() => {
                        $scope.sort = attr.sortBy;
                    })
                }
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/directives/sort-by.directive.js